import { useFormat } from '@ideavivat/vivat-2';
import { purchase_request } from './base';

export default {
  types: {
    _increment: {
      name: 'ลำดับ',
      width: '4rem',
      class: 'text-center',
    },
    // type: {
    //   name: 'ประเภท',
    //   width: '6rem',
    // },
    purchase_request,
    description: {
      name: 'รายละเอียด',
      width: '1fr',
    },
    neededAmount: {
      name: 'จำนวนที่ต้องการ / ซื้อแล้ว',
      width: '12rem',
      class: 'text-center',
      filter: (val: string) => parseFloat(val || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
    },
    amount: {
      name: 'จำนวนที่สั่งซื้อ',
      width: '10rem',
      class: 'text-center',
    },
    pricePerUnit: {
      name: 'ราคาต่อหน่วย',
      width: '8rem',
      class: 'text-right',
    },
    unit: {
      name: 'หน่วยสั่งซื้อ',
      width: '8rem',
      class: 'text-left',
    },
    totalPrice: {
      name: 'รวมยอด',
      width: '6rem',
      filter: (val: string, row: any) => parseFloat(`${row.item.amount * row.item.pricePerUnit}` || '0').toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
      class: 'text-right',
    },
    target_date: {
      name: 'กำหนดส่ง',
      width: '8rem',
      class: 'text-center',
      // eslint-disable-next-line
      filter: (val: string) => val ? useFormat.date(val).displayShortThaiDate() : '',
    },
  },
};
